<cc-casino-grid-on-lobby-type
    [lobbyType]="lobbyType"
    [categoryRoute]="routeCategoryType"
    [gameContainer]="'Page Container'"></cc-casino-grid-on-lobby-type>
